import { useEffect, useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import Screen from "components/Meta/Screen";
import { fetchCounts } from "../helpers/counts";
import { TAB_COUNTS } from "../constants";

function MelhousPage({ view, children }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const sources = TAB_COUNTS.filter((source) => source.id === view);
    if (!sources.length) return undefined;
    let cancelled = false;
    async function load() {
      const result = await fetchCounts(sources);
      if (!cancelled) setCount(result[view]);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [view]);

  return (
    <Screen style="w-full flex flex-col bg-neutral-100">
      <header className="px-3 lg:px-4 pt-4 pb-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-neutral-500">
          Melhous
        </p>
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-2xl md:text-3xl font-light text-neutral-700">
            <FM id={`melhous.dash.tab.${view}`} />
          </h1>
          {count > 0 && (
            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-900">
              <FM id="melhous.dash.tab.pending" values={{ count }} />
            </span>
          )}
        </div>
        <p className="text-sm text-neutral-500">
          <FM id={`melhous.dash.tab.${view}_help`} />
        </p>
      </header>
      <main className="w-full flex-1">{children}</main>
    </Screen>
  );
}

export default MelhousPage;
